// Budget Tutorial — a presentation-grade guided tour of the budget module
// for tax/FP&A users who own Tax Budget FY2026.xlsx today. Route:
// /budget/tutorial. Everything on this page runs on embedded mock data —
// zero API calls — so it presents safely on any machine with no backend.
// Sections and demos live isolated in frontend/src/tutorial/ (nothing else
// imports from there except this page + the navbar link).

import React from 'react';
import NavHeader from '../components/NavHeader';
import HeroSection from '../tutorial/HeroSection';
import WorkbookMapSection from '../tutorial/WorkbookMapSection';
import AccrualTimelineSection from '../tutorial/AccrualTimelineSection';
import TryItSection from '../tutorial/TryItSection';
import ScreenshotsSection from '../tutorial/ScreenshotsSection';
import FooterSection from '../tutorial/FooterSection';
import '../tutorial/Tutorial.css';

export default function BudgetTutorial() {
  return (
    <>
      <NavHeader />
      <div className="tut-page">
        <HeroSection />
        <WorkbookMapSection />
        <AccrualTimelineSection />
        <TryItSection />
        <ScreenshotsSection />
        <FooterSection />
      </div>
    </>
  );
}
